<template>
  <div :class="componentClass.root" :style="styles">
    <div :class="componentClass.element('label')">
      {{ label }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useComponentClass } from '@thomasaull-shared/composables'
import { formatWithLocale } from '@/utilities/date'

export interface Props {
  date: Date
  numberOfDays: number
}

const props = defineProps<Props>()

const store = useStore()
const componentClass = useComponentClass({ props })

const label = computed(() => formatWithLocale(props.date, 'MMMM yyyy'))

const styles = computed(() => {
  const dayWidth = store.state.cssVar.variables.dayWidth.value

  return {
    width: `${props.numberOfDays * dayWidth}px`,
  }
})
</script>

<style lang="scss">
.PmCalendarMonthPure {
  $block: &;

  display: flex;

  &-label {
    @include mixin.textLabel;

    position: sticky;
    left: var(--sidebarLeftWidth);
    width: auto;
    padding-left: var(--space-gutters);
    padding-right: var(--space-gutters);
    flex: none;
  }
}
</style>
